// src/hooks/useUserPermissions.js
import { useState, useEffect } from "react";
import { fetchUserPermissions } from "../../services/permissionService";

const useUserPermissions = () => {
    const [userPermissions, setUserPermissions] = useState([]);

    useEffect(() => {
        const retrievedUserID = localStorage.getItem('userID');
        if (retrievedUserID) {
            fetchUserPermissions(retrievedUserID).then(data => {
                setUserPermissions(data);
            });
        }
    }, []);

    return userPermissions;
};

export default useUserPermissions;


